import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack } from "@mui/system";
import { Button, LinearProgress } from "@mui/material";
import AlertDialogComponent from "../../../components/AlertDialogComponent";
import { deletePrize, getPrizes } from "../../../redux/slices/adminSlice";
import { setNotification } from "../../../redux/slices/notificationsSlice";
import { getMe } from "../../../redux/slices/userSlice";
import EditGiftModal from "./EditGiftModal";

const GiftsTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const allPrizes = useSelector((state) => state.admin.allPrizes);
  const getPrizesLoading = useSelector((state) => state.admin.getPrizesLoading);
  const getPrizesError = useSelector((state) => state.admin.getPrizesError);

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningModalTitle, setWarningModalTitle] = useState("");
  const [itemToDelete, setItemToDelete] = useState("");
  const [giftToEdit, setGiftToEdit] = useState();
  const [showEditGiftModal, setShowEditGiftModal] = useState();

  const columns = [
    // { id: "available", label: t("adminGifts.available"), minWidth: 170 },
    { id: "name", label: t("adminGifts.name"), minWidth: 170 },
    { id: "stock", label: t("adminGifts.stock"), minWidth: 100 },
    {
      id: "points",
      label: t("adminGifts.points"),
      minWidth: 170,
    },
    {
      id: "photo",
      label: t("adminGifts.photo"),
      minWidth: 170,
    },
    {
      id: "action",
      label: t("adminGifts.actions"),
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const getIconForVerify = (value) => {
    return value ? <CheckCircleIcon /> : <DoDisturbIcon />;
  };
  const onEditAction = (gift) => {
    setGiftToEdit(gift);
    setShowEditGiftModal(true);
  };
  // const onDisableAction = (prize) => {
  //   dispatch(
  //     togglePrizeAvailability({
  //       objectId: prize.objectId,
  //       available: !prize.available,
  //     })
  //   ).then(
  //     (response) => {
  //       dispatch(getMe()).then(() => dispatch(getPrizes()));
  //       dispatch(
  //         setNotification({
  //           show: true,
  //           message: t("notifications.successEditGift"),
  //           variant: "success",
  //         })
  //       );
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // };
  const onDeleteAction = (prize) => {
    setItemToDelete(prize);
    setWarningModalTitle(t("adminGifts.warningDelete"));
    setShowWarningModal(true);
  };
  const onCloseWarningModal = () => {
    setItemToDelete(null);
    setWarningModalTitle("");
    setShowWarningModal(false);
  };
  const handleOnConfirm = () => {
    itemToDelete &&
      dispatch(deletePrize({ prizeId: itemToDelete.objectId })).then(
        (response) => {
          dispatch(getMe()).then(() => dispatch(getPrizes()));
          dispatch(
            setNotification({
              show: true,
              message: t("notifications.successDeletedGift"),
              variant: "success",
            })
          );
          onCloseWarningModal();
        },
        (err) => {
          dispatch(
            setNotification({ show: true, message: err, variant: "error" })
          );
        }
      );
  };
  const handleOnCloseEditGiftModal = () => {
    setShowEditGiftModal(false);
    setGiftToEdit(null);
  };
  const handleOnSuccessEditGift = () => {
    handleOnCloseEditGiftModal();
    dispatch(getMe()).then(() => dispatch(getPrizes()));
  };
  const getColumn = (value, column) => {
    const isActionColumn = column.id === "action";
    let content = null;

    if (isActionColumn) {
      content = (
        <TableCell key={column.id} align={column.align}>
          <Stack direction="column">
            <Button onClick={() => onEditAction(value)} variant="contained">
              {t("adminGifts.edit")}
            </Button>
            {/* <Button
              onClick={() => onDisableAction(value)}
              sx={{ marginTop: "8px", marginBottom: "8px" }}
            >
              {t(value.available ? "adminGifts.disable" : "adminGifts.enable")}
            </Button> */}
            <Button
              sx={{ marginTop: "12px" }}
              onClick={() => onDeleteAction(value)}
              color="error"
            >
              {t("adminGifts.delete")}
            </Button>
          </Stack>
        </TableCell>
      );
    } else if (column.id === "photo") {
      content = (
        <TableCell key={column.id} align={column.align}>
          <img src={value?.url} alt="prize-img" height="150px" width="150px" />
        </TableCell>
      );
    } else {
      content = (
        <TableCell key={column.id} align={column.align}>
          {column.id === "available" ? getIconForVerify(value) : value}
        </TableCell>
      );
    }

    return (
      <TableCell key={column.id} align={column.align}>
        {content}
      </TableCell>
    );
  };
  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {getPrizesLoading === "PENDING" ? (
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          ) : (
            <TableBody>
              {allPrizes
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((prize) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={prize.objectId}
                    >
                      {columns.map((column) => {
                        const value =
                          column.id === "action" ? prize : prize[column.id];
                        return getColumn(value, column);
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={allPrizes?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <AlertDialogComponent
        open={showWarningModal}
        onClose={onCloseWarningModal}
        title={warningModalTitle}
        onConfirm={handleOnConfirm}
      />
      {showEditGiftModal && (
        <EditGiftModal
          open={showEditGiftModal}
          onClose={handleOnCloseEditGiftModal}
          giftToEdit={giftToEdit}
          onSuccessEditGift={handleOnSuccessEditGift}
        />
      )}
    </Paper>
  );
};
export default GiftsTable;
